module.exports = __webpack_public_path__ + "static/img/bgg.47acd1c.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/bgg.png
// module id = eca3
// module chunks = 18